








import { IReferenceAlbum } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({})
export default class FactoryReferenceItem extends Vue {
    @Prop()
    public referenceItem: IReferenceAlbum;

    @Action("setCurrentMediaIndex")
    public setCurrentMediaIndex: any;

    @Action("fetchAlbum")
    public fetchAlbum: any;

    @Action("openGallery")
    public openGallery: any;

    public getBackgroundImageLink() : string {
        return "url(" + process.env.VUE_APP_DOMAIN + "/static/" + this.referenceItem.src + ")";
    }

    public async showAlbum() : Promise<any> {
        await this.fetchAlbum(this.referenceItem.id);
        await this.setCurrentMediaIndex(0);
        await this.openGallery();
    }

    public handleImageChange(index: number) : void {
        this.setCurrentMediaIndex(index);
    }
}
